/**
 * Enhanced Framework Router
 * 
 * This component routes to the appropriate enhanced framework page based on the ID.
 * It serves as a central dispatcher for all enhanced M2 frameworks.
 */

import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { desiredOutcomeFramework } from '../data/enhanced/desiredOutcomeFramework';
import { outcomeDriverFramework } from '../data/enhanced/outcomeDriverFramework';
import { strategyDeliveryCascade } from '../data/enhanced/strategyDeliveryCascade';
import { stateClassificationModel } from '../data/enhanced/stateClassificationModel';
import { EnhancedFrameworkEntryPage } from './EnhancedFrameworkEntry';
import type { EnhancedFrameworkEntry } from '../types/enhancedFramework';

/**
 * Map of framework IDs to their data
 */
const enhancedFrameworkData: Record<string, EnhancedFrameworkEntry> = {
  'mof.strategy_delivery_cascade_by_scope': strategyDeliveryCascade,
  'gf.desired.outcome': desiredOutcomeFramework,
  'gf.outcome.driver': outcomeDriverFramework,
  'meta.modality.state.topology': stateClassificationModel,
};

export const EnhancedFrameworkRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  if (!id) {
    return <Navigate to="/elevation/models" replace />;
  }
  
  const frameworkData = enhancedFrameworkData[id];
  
  if (!frameworkData) {
    return <Navigate to="/elevation/models" replace />;
  }
  
  return <EnhancedFrameworkEntryPage framework={frameworkData} />;
};

